import React, { useState, useEffect } from "react";
import { LoadingIcon } from '@prosolve/common-components-ui'
import Cookies from 'js-cookie';
import useFetch from '../../hooks/useFetch';
import TrainerCompensationCard from "./TrainerCompensationCard";

export default () => {
  const userId = Cookies.get('loggedInUserId');

  const [isLoading, setIsLoading] = useState(true)
  const [recentCompensationData, setRecentCompensationData] = useState([]);

  const fetch = useFetch();

  const fetchRecentCompensationData = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`trainer/recentCompensation?userId=${userId}`, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setRecentCompensationData([])
      } else {
        setRecentCompensationData(jsonData)
      }
    } catch (e) {
      setRecentCompensationData([])
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchRecentCompensationData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      style={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{
        flex: 1,
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        marginLeft: '20px'
      }}>
        {`Recent Compensation`}
      </div>
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div style={{
            flex: 1,
            display: 'flex',
            columnGap: '20px',
            rowGap: '20px',
            padding: '20px',
            flexWrap: 'wrap'
          }}>
            {
              recentCompensationData.map((compData = {}) => 
                <TrainerCompensationCard key={compData.id} compensationData={compData} />
              )
            }
          </div>
      }
    </div>
  )
}